import { render, staticRenderFns } from "./SupplySkuInsightPanel.vue?vue&type=template&id=5297c916&scoped=true"
import script from "./SupplySkuInsightPanel.vue?vue&type=script&lang=js"
export * from "./SupplySkuInsightPanel.vue?vue&type=script&lang=js"
import style0 from "./SupplySkuInsightPanel.vue?vue&type=style&index=0&id=5297c916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5297c916",
  null
  
)

export default component.exports